
define('text!templates/modules/setting/personal/blocks/custom-messages/custom-messages-content.html',[],function () { return '<div id="custom-messages-content" class="panel-body">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div id="custom-message-list"></div>\n</div>\n';});

